import React, {
  forwardRef,
  useImperativeHandle,
  useLayoutEffect,
  useRef,
  useState,
} from 'react'

export const CustomTooltip = forwardRef((props, ref) => {
  const {
    className,
    payload,
    getJSX,
    useBarIndex = true,
    active,
    coordinate,
    onPositionUpdate,
    onPositionClear,
  } = props
  const [barIndex, setBarIndex] = useState(null)
  const tooltipElementRef = useRef()
  const updateBarIndex = (idx) => {
    setBarIndex(idx)
  }

  const resetBarIndex = () => {
    setBarIndex(null)
  }

  useImperativeHandle(ref, () => ({
    updateBarIndex,
    resetBarIndex,
    tooltipElementRef,
  }))

  const isBarIndexHidden = useBarIndex && barIndex === null
  const tooltip = isBarIndexHidden ? null : getJSX(payload, barIndex)
  const hasTooltip = Boolean(tooltip)

  useLayoutEffect(() => {
    if (!onPositionUpdate && !onPositionClear) return
    if (active && hasTooltip) {
      onPositionUpdate?.(coordinate)
    } else {
      onPositionClear?.()
    }
  }, [active, coordinate, hasTooltip, onPositionUpdate, onPositionClear])

  if (isBarIndexHidden) return null
  if (tooltip)
    return (
      <div ref={tooltipElementRef} className={`chart-tooltip ${className}`}>
        {tooltip}
      </div>
    )
  return <div />
})
